var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{ref:"text",staticClass:"slide",style:({'--timeAnimation': `${_vm.time}s`})},[_c('span',{staticClass:"slide__text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('scroll-down-icon',{attrs:{"time":_vm.time}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }